import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Modal,
  ModalBody,
} from 'reactstrap';
import * as Yup from 'yup';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { Formik, Field, Form } from 'formik';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import FaxPopup from 'components/FaxPopup';
import ReactStrapTable from 'components/reactStrapTable';
import Checkbox from 'components/common/Fields/Checkbox';
import { cellRendererCheck, currencyFormat } from 'utils/columns';
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikSelectField from 'components/common/Fields/FormikSelectField';

const validationSchema = Yup.object({
  reasonDesc: Yup.string().required('Reason description is required'),
  // reason_for_approving: Yup.string().required("Reason for approving is required"),
});

const reason_for_approving = [
  {
    id: 4,
    code: 'MNA',
    description: 'Manual Approve',
  },
  {
    id: 5,
    code: 'MNR',
    description: 'Manual Reject',
  },
];

const ClaimApproveReject = (props) => {
  const API = useAxios();
  const { ids, type, toggle, close, rxNumbers, refetchdata, tenantID, coveredEntityID  } = props;
  const [faxPopup, setFaxPopup] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [reasonsForApproving, setReasonsForApproving] =
    useState(reason_for_approving);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedClaimsIds, setSelectedClaimsIds] = useState(
    Array.isArray(ids) ? [...ids] : []
  );
  const [data, setData] = useState([]);
  const [hasCaptureAssociated, setHasCaptureAssociated] = useState(true);
  const [captureFutureRefill, setCaptureFutureRefill] = useState(false);
  // const { tenantID, coveredEntityID } = useParams();
  const [captureDetails, setCaptureDetails] = useState({});

  const hasApprove = type === 'approve';

  const defaultoption = hasApprove
    ? reasonsForApproving[0]
    : reasonsForApproving[1];

  const fetchReasons = async () => {
    setLoading(true);
    let url = '';
    if (type === 'approve') {
      url = 'ApprovedReason';
    } else if (type === 'reject') {
      url = 'RejectionReason';
    }
    try {
      const { data } = await API.get(`RCMConfig/TypeStatus/${url}`, {
        hasDefaultURL: true,
        hideLoader: true,
      });
      if (data) {
        // setReasonsForApproving(data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const featchClaimAssociated = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/Associated/${coveredEntityID}`,
        ids,
        {
          hideLoader: true,
        }
      );
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReasons();
    featchClaimAssociated();
  }, []);

  const handleFax = () => {
    setFaxPopup((pre) => !pre);
  };

  const handleApprove = async (variables) => {
    try {
      const { data } = await API.post(`/${tenantID}/Claim/Approve`, variables);
      setSubmitting(false);
      return data;
    } catch (error) {
      setSubmitting(false);
    }
  };
  const handleReject = async (variables) => {
    try {
      const { data } = await API.post(`/${tenantID}/Claim/Reject`, variables);
      setSubmitting(false);
      return data;
    } catch (error) {
      toast.error('An error occurred');
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setOpen(!isOpen);
    setCaptureDetails({});
  };

  const handleContinue = async () => {
    setSubmitting(true);
    if (type === 'approve') {
      const result = await handleApprove(captureDetails);
      if (result) {
        refetchdata();
        toast.success('Approval Done');
        close();
      }
    } else {
      const result = await handleReject(captureDetails);
      if (result) {
        toast.success('Rejection Done');
        refetchdata();
        close();
      }
    }
    setOpen(false);
  };

  const handleSubmit = ({ reasonDesc, reasonsForApproving }, actions) => {
    const obj = {
      reasonId: parseInt(defaultoption.id),
      reasonDesc,
      captureFutureRefill,
      claimIds: hasCaptureAssociated ? selectedClaimsIds : ids,
      ceid: parseInt(coveredEntityID),
    };
    setCaptureDetails(obj);
    setOpen(!isOpen);
  };

  const handleChangeAssociated = ({ target: { value } }) => {
    const val = value === 'true';
    setHasCaptureAssociated(!val);
  };

  const dateFormate = (row, value) => {
    const { dateofService } = row;
    return <span>{moment(new Date(dateofService)).format('MM/DD/YYYY')}</span>;
  };

  const onChange = (claim) => {
    const { claimID } = claim;
    const filter = selectedClaimsIds.filter((item) => item === claimID);
    if (filter.length > 0) {
      const remove = selectedClaimsIds.filter((item) => item !== claimID);
      setSelectedClaimsIds([...remove]);
    } else {
      setSelectedClaimsIds((pre) => [...pre, claimID]);
    }
  };

  const checkboxWithRXNumber = (claim) => {
    const { refillNumber, isDefault } = claim;
    return (
      <>
        {' '}
        <Checkbox value={isDefault} onChange={() => onChange(claim)} />
        &nbsp;
        <span>{refillNumber}</span>
      </>
    );
  };

  const columns = [
    {
      dataField: 'refillNumber',
      text: 'Refill#',
      sort: true,
      cellRenderer: (row) => checkboxWithRXNumber(row),
      headerStyle: { width: '144px' },
      disabled: true,
    },
    {
      dataField: 'rxNumber',
      text: 'Rx#',
      sort: true,
      headerStyle: { width: '144px' },
      disabled: true,
      cellRenderer: (row) => cellRendererCheck(row.rxNumber),
    },
    {
      dataField: 'dateofService',
      text: 'Date of Service',
      cellRenderer: (row) => dateFormate(row, 'dateofService'),
      headerStyle: { width: '144px' },
      disabled: true,
    },
    {
      dataField: 'ndc',
      text: 'NDC',
      headerStyle: { width: '144px' },
      disabled: true,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: 'drugName',
      text: 'Drug Name',
      headerStyle: { width: '144px' },
      disabled: true,
      cellRenderer: (row) => cellRendererCheck(row.drugName),
    },
    {
      dataField: 'ceReceivable',
      text: 'CE Receivable',
      width: 125,
      disabled: true,
      cellRenderer: (row) => currencyFormat(row.ceReceivable),
      className: 'text-end',
    },
    {
      dataField: 'profitLoss',
      text: 'Profit/Loss',
      width: 125,
      disabled: true,
      cellRenderer: (row) => currencyFormat(row.profitLoss),
      className: 'text-end',
    },
    {
      dataField: 'totalPaid',
      text: 'Total Amount Paid',
      width: 125,
      disabled: true,
      cellRenderer: (row) => currencyFormat(row.totalPaid),
      className: 'text-end',
    },
  ];

  return (
    <>
      <Card className='border-0 rounded shadow-top'>
        <CardBody>
          <Formik
            initialValues={{
              reasonDesc: '',
              reasonForApproving: '',
              hasCaptureAssociated: true,
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            children={(props) => {
              return (
                <Form>
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Field
                          label={`Reason for ${
                            type === 'approve' ? 'Approving' : 'Rejecting'
                          }`}
                          required
                          name='reasonForApproving'
                          type='text'
                          component={FormikSelectField}
                          options={reasonsForApproving}
                          // defaultoption="--Select--"
                          defaultoption={defaultoption.description}
                          keys={{
                            id: 'id',
                            label: 'description',
                          }}
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>
                    <Col className='text-end'>
                      {' '}
                      <Button color='primary' type='submit' disabled={loading}>
                        {type === 'approve' ? 'Approve' : 'Reject'}
                      </Button>
                      {/* //Hide for now------// */}
                      {/* <Button
                        type='button'
                        color='primary'
                        onClick={handleFax}
                        disabled={true}
                      >
                        <FontAwesomeIcon icon={faPrint} className='me-2' />
                        Fax
                      </Button> */}
                      {faxPopup && <FaxPopup handleFax={handleFax} />}
                    </Col>
                  </Row>
                  <FormGroup className='w-50'>
                    <Field
                      id='Reason'
                      name='reasonDesc'
                      required
                      type='textarea'
                      component={FormikInputField}
                      label='Reason'
                      placeholder='Reason'
                    />
                  </FormGroup>
                  <FormGroup className='mb-3 mt-3' check inline>
                    <Input
                      onChange={handleChangeAssociated}
                      type='checkbox'
                      checked={hasCaptureAssociated}
                      value={hasCaptureAssociated}
                    />
                    <Label check>
                      {type === 'approve' ? 'Approve' : 'Reject'} Associated
                      Refills
                    </Label>
                  </FormGroup>
                  <Card className='table-card position-relative border-0'>
                    <CardBody className='p-0'>
                      {hasCaptureAssociated && (
                        <ReactStrapTable
                          id='claim-captured-selected'
                          height={50 * data.length}
                          columns={columns}
                          data={data}
                          loading={loading}
                        />
                      )}
                    </CardBody>
                  </Card>
                </Form>
              );
            }}
          ></Formik>
        </CardBody>
      </Card>
      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalBody className='m-2 p-4'>
          {submitting && <Loader opacity={0.01} color='black' />}
          <h6 className='f-24 '>Confirmation!</h6>
          <p className='f-14 font-weight-400'>
            Are you sure you want to {hasApprove ? 'approve' : 'reject'} the
            claim for{' '}
            <strong>
              Rx# {rxNumbers && rxNumbers.length ? rxNumbers.join(', ') : ''}
            </strong>
            ?
          </p>
          <div className='text-end pt-4'>
            <Button color='cancel' outline onClick={handleCancel}>
              No, Cancel
            </Button>
            <Button color='primary' onClick={handleContinue}>
              Yes, {hasApprove ? 'Approve' : 'Reject'}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ClaimApproveReject;
